import { Component } from '@angular/core';
import { MenuController, NavController, Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthProps, AuthRepository } from 'src/app/auth/state/auth.repository';
import { UserEffortService } from 'src/app/services/firebase/user-effort.service';
import { UserEvaluationService } from 'src/app/services/firebase/user-evaluation.service';
import { UserTimeService } from 'src/app/services/firebase/user-time.service';
import { WeekCalculatorService } from 'src/app/services/week-calculator.service';
import SwiperCore, { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';
SwiperCore.use([Autoplay, Keyboard, Pagination, Scrollbar, Zoom]);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.scss'],
})
export class DashboardPage {

  totalClients = 0;
  monthAppointments = 0;
  totalAppointments = 0;
  barChartData: any = {};

  authState$: Observable<AuthProps>;

  currentWeek: number = 1;


  constructor(
    private platform: Platform,
    private menuCtrl: MenuController,
    private authRepo: AuthRepository,
    private navCtrl: NavController,
    private userEffortService: UserEffortService,
    private userEvaluationService: UserEvaluationService,
    private userTimeService: UserTimeService,
    private weekCalc: WeekCalculatorService,
  ) {
    this.authState$ = this.authRepo.state$
    this.currentWeek = this.weekCalc.calcWeekNumber(this.authRepo.getState().user.start_at);
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(true)
  }

  onClick(site: string) {
    switch (site) {
      case 'gmail':
        this.email()
        break;
      case 'cartilha':
        window.open('./assets/content/cartilha.pdf', '_system', 'location=yes');
        break;
      case 'whatsapp':
        this.whatsapp()
        break;
      case 'training':
        this.navCtrl.navigateForward('/weeks');
        break
      case 'messages':
        this.navCtrl.navigateForward('/messages');
        break
    }
  }

  email() {
    const link = document.createElement('a')
    link.href = "mailto:test@test.com"
    document.body.appendChild(link);
    link.click()
  }

  whatsapp() {
    const wppnumber = '5551996083582';
    let whatsappMessage = "";
    const api = this.platform.is('mobile')
      ? `whatsapp://send?phone=${wppnumber}&text=`
      : `https://wa.me/${wppnumber}?text=`;
    let url: string = '';
    whatsappMessage = window.encodeURIComponent("Olá, estou precisando de ajuda ");
    url = api + whatsappMessage;
    window.open(url, '_blank');
  }

}
